module.exports = __webpack_public_path__ + "img/xmasParty13.f831c908.jpg";